<style scoped>
.ipt-sty {
  width: 70% !important;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <p class="t-left font-S14 fontC-4fa1a4 mb20" v-show="$route.query.pageTitle">{{$route.query.pageTitle}}</p>
      <el-row :gutter="20">
        <el-col :span="7"
          ><div class="search-area-div">岗位：</div>
          <el-input v-model="page.positionName" class="ipt-sty" placeholder="请输入岗位" :clearable="true"></el-input
        ></el-col>
        <el-col :span="7">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加岗位</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <div class="fr line-h40 h40 font-S16 mr16">{{tenantName}}，有<b class="fontC-4fa1a4"> {{page.totalRows}} </b>个人员</div>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;" v-loading="loading">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="positionName" label="岗位" header-align="center" align="center"></el-table-column>
        <el-table-column prop="positionPeopleNum" label="使用人员数量" header-align="center" align="right"></el-table-column> 
        <el-table-column prop="bizState" label="状态" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.bizState | getBizState }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="岗位:" prop="positionName">
          <el-input v-model="ruleForm.positionName" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <!-- <el-form-item label="显示顺序:" prop="orderNum">
          <el-input v-model="ruleForm.orderNum" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="状态:" class="t-left">
          <el-radio v-model="ruleForm.bizState" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.bizState" label="S">停用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '添加岗位'" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      ruleForm: {
        guid: '',
        positionName: '',
        orderNum: '', 
        bizState: 'Y',
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        guid: '',
        tenantGuid: '',
        positionName: '', 
      },
      loading:false,
      tableData: [],
      rules: {
        positionName: [
          { required: true, message: '请输入岗位', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        orderNum: [
          { required: true, message: '请输入顺序', trigger: 'blur' },
          { min: 1, max: 60, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ], 
      },
      multipleSelection: [],
      tenantName:'',
    };
  },
  created() {
    this.tenantName = this.$route.query.tenantName;
    // 列表
    this.getData(false);
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        guid: '',
        tenantGuid: self.$route.query.tenantGuid,
        positionName: '', 
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.page.tenantGuid = self.$route.query.tenantGuid;
      self.api.postJson(`/${serverConfig.msPersonnelService}/position/data/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.loading = false;
          // self.tableData.forEach(function(item) {
          //   item.bizState = item.bizState == 'Y' ? '有效' : '停用';
          // });
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('当前岗位有用户使用，是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msPersonnelService}/position/data/delete`, self.multipleSelection)
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除岗位成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '添加岗位';
        self.ruleForm.positionName = '';
        self.ruleForm.orderNum = '';
        self.ruleForm.bizState = 'Y';
      } else {
        self.textTitle = '编辑岗位';
        self.ruleForm.guid = row.guid; 
        self.ruleForm.positionName = row.positionName;
        self.ruleForm.orderNum = row.orderNum;
        self.ruleForm.bizState = row.bizState;
      }
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      let self = this;
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            tenantGuid: self.page.tenantGuid,
            positionName: self.ruleForm.positionName,
            orderNum: self.ruleForm.orderNum,
            bizState: self.ruleForm.bizState,
          };
          self.api.postJson(`/${serverConfig.msPersonnelService}/position/data/add`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('添加岗位成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            guid: self.ruleForm.guid,
            tenantGuid: self.page.tenantGuid,
            positionName: self.ruleForm.positionName,
            orderNum: self.ruleForm.orderNum,
            bizState: self.ruleForm.bizState,
          };
          self.api.put(`/${serverConfig.msPersonnelService}/position/data/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('编辑岗位成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
